export default __webpack_public_path__ + "static/media/SavedIconProperty.f4118aea.svg";